export default function createLegacyUrl(path: string) {
    return `${import.meta.env.VITE_LEGACY_APP_HOST}/${path}`;
}
